import { getEmptyConfigByKey, getDb } from '../../../../components/utils/indexedDbUtils'
import _ from 'lodash'

export default async function updateCampaignSectionDDS ({ commit, getters }, payload, recordType) {
  const { data, section } = payload

  const { config, flat } = data

  const currentCampaign = getters.state.currentCampaign
  if (config) {
    if (section === 'campaignData') {
      const oldData = currentCampaign.config.campaignData
      const newData = config

      const oldChannels = oldData.campaignChannel.selected
      const newChannels = newData.campaignChannel.selected

      if (recordType === 'ddsChild' && JSON.stringify(oldChannels) !== JSON.stringify(newChannels)) {
        const db = await getDb()
        const emptyConfig = (await getEmptyConfigByKey('DDSCHILD', db)).config.contentSelection
        const contentSelectionObject = {}

        commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'contentSelection', data: {} })
        config.campaignChannel.selected.forEach(channel => {
          const template = _.cloneDeep(emptyConfig[channel])
          contentSelectionObject[channel] = template
        })

        commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'contentSelection', data: _.cloneDeep(contentSelectionObject) })
      }
    }
    commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section, data: _.cloneDeep(config) })
  }

  if (flat) {
    Object.keys(flat).forEach(key => {
      commit('SET_CAMPAIGN_FIELD', { name: key, value: _.cloneDeep(flat[key]) })
    })
  }
}
